export default __webpack_public_path__ + "static/media/postease-1497-new.367e800d.png";